import React, { useState } from 'react'
import './index.css'
import { connect } from 'react-redux'
import {
  useHistory,
  withRouter,
} from 'react-router-dom'
import { setReportsToDealers } from '../../store/actions'
import DatePickerReports from '../DatePickerReports'

// page="user" description={elem.description} key={index}  reportName={elem.reportName} paramType={elem.parmType}
const ReportFrame = ({description, page, reportName, paramType, setReportsToDealers}) => {
  let history = useHistory()
  const [ showDatePickerDealerReports, setShowDatePickerDealerReports ] = useState(false)

  const toggleDatePickerDealerReports = () => {
    setShowDatePickerDealerReports(!showDatePickerDealerReports)
  }

  const selectReport = () => {
    if (paramType === 'time_range') {
      toggleDatePickerDealerReports()
    } else {
      setReportsToDealers(reportName)
      history.push(`/${page}/general/reports/${reportName}`)
    }
  };
  return (
    <div className='frame__box'>
      <p className='frame__description'>{description}</p>
      <div className='frame__line'/>
      <button className='btn frame__btn' onClick={selectReport}>View Report</button>
      {
        showDatePickerDealerReports &&
        <DatePickerReports reportName={reportName} paramType={paramType} toggleModal={toggleDatePickerDealerReports} />
      }
    </div>
  )
}
const mapStateToProps = (state) => ({
  // jobReports: state.reports.jobReports,
  // dealerReports: state.reports.reports.dealer_report,
  // employeeReports: state.reports.reports.user_report,
  // listJobReports: state.reports.jobReports,
  // listDealerReports: state.reports.dealersReports,
  // listUserReports: state.reports.userReports,
  // startDateReport: state.reports.startDateReport,
  // endDateReport: state.reports.endDateReport
})

const mapDispatchToProps =
  {
    setReportsToDealers,
  }

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportFrame))

